import React from "react";
import PropTypes from "prop-types";
import {
  ModalOverlay,
  ModalContent,
  ModalMessage,
  ModalBody,
  ModalActions,
  ModalButton,
  CloseButton,
  IconWrapper
} from "../styles";

const ApprovalModal = ({ data, isLoading, error, onClose, onConfirm }) => {
  if (!data) {
    return null;
  }

  const hasError = Boolean(error);

  const handleOverlayClick = () => {
    if (!isLoading) {
      onClose();
    }
  };

  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  const handleConfirm = () => {
    onConfirm(data.issuerPaymentId);
  };

  const handleClose = () => {
    if (!isLoading) {
      onClose();
    }
  };

  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContent onClick={handleContentClick}>
        <CloseButton onClick={handleClose} aria-label="Cerrar" disabled={isLoading}>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </CloseButton>
        <ModalBody style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", boxSizing: "border-box" }}>
          <IconWrapper>
            {hasError ? (
              <svg
                viewBox="0 0 64 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="32" cy="32" r="26.67" fill="#E53E3E" />
                <line x1="22" y1="22" x2="42" y2="42" stroke="white" strokeWidth="4" strokeLinecap="round" />
                <line x1="42" y1="22" x2="22" y2="42" stroke="white" strokeWidth="4" strokeLinecap="round" />
              </svg>
            ) : (
              <svg
                viewBox="0 0 64 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="32" cy="32" r="26.67" fill="#0BBEF0" />
                <circle cx="32" cy="23.11" r="4.44" fill="white" />
                <rect
                  x="27.56"
                  y="30.22"
                  width="8.89"
                  height="20.74"
                  rx="4.44"
                  fill="white"
                />
              </svg>
            )}
          </IconWrapper>

          {/* Mensajes */}
          {hasError ? (
            <>
              <ModalMessage style={{ color: "#E53E3E", textAlign: "center", width: "100%" }}>
                Ocurrió un error
              </ModalMessage>
              <ModalMessage style={{ fontSize: "14px", color: "#666", textAlign: "center", width: "100%" }}>
                No se pudo procesar la aprobación. Por favor intenta de nuevo.
              </ModalMessage>
            </>
          ) : isLoading ? (
            <>
              <ModalMessage style={{ textAlign: "center", width: "100%" }}>
                Procesando aprobación...
              </ModalMessage>
              <ModalMessage style={{ fontSize: "14px", color: "#666", textAlign: "center", width: "100%" }}>
                Por favor espera un momento
              </ModalMessage>
            </>
          ) : (
            <>
              <ModalMessage style={{ textAlign: "center", width: "100%" }}>
                Al continuar estarás aprobando y aceptando seguir con tu pago.
              </ModalMessage>
              <ModalMessage style={{ textAlign: "center", width: "100%" }}>¿Deseas continuar?</ModalMessage>
            </>
          )}
        </ModalBody>

        <ModalActions>
          {hasError ? (
            <ModalButton variant="primary" onClick={handleClose}>
              Cerrar
            </ModalButton>
          ) : (
            <>
              <ModalButton 
                variant="secondary" 
                onClick={handleClose}
                disabled={isLoading}
              >
                Cancelar
              </ModalButton>
              <ModalButton 
                variant="primary" 
                onClick={handleConfirm}
                disabled={isLoading}
              >
                {isLoading ? "Procesando..." : "Continuar"}
              </ModalButton>
            </>
          )}
        </ModalActions>
      </ModalContent>
    </ModalOverlay>
  );
};

ApprovalModal.propTypes = {
  data: PropTypes.shape({
    issuerPaymentId: PropTypes.number.isRequired,
    campaignName: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired
  }),
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

ApprovalModal.defaultProps = {
  data: null,
  isLoading: false,
  error: null
};

export default ApprovalModal;
